import api from "../../../shared/api";

/**
 * Fetch integration & configuration health checks.
 */
export async function getSystemHealth() {
  return api.get("/system/health/integrations");
}
